'use strict';

var _ = require('lodash');

var util = {
    /**
	 * @function
	 * @description appends the parameter with the given name and value to the given url and returns the changed url
	 * @param {string} url the url to which the parameter will be added
	 * @param {string} name the name of the parameter
	 * @param {shouldtring} value the value of the parameter
	 * @returns {string} url
	 */
    appendParamToURL: function (url, name, value) {
        // quit if the param already exists
        if (url.indexOf(name + '=') !== -1) {
            return url;
        }
        var separator = url.indexOf('?') !== -1 ? '&' : '?';
        return url + separator + name + '=' + encodeURIComponent(value);
    },

    /**
	 * @function
	 * @description appends the parameters to the given url and returns the changed url
	 * @param {string} url the url to which the parameters will be added
	 * @param {Object} params - parameters to be added
	 * @returns {string} url
	 */
    appendParamsToUrl: function (url, params) {
        // eslint-disable-next-line no-underscore-dangle
        var _url = url;
        _.each(
            params,
            function (value, name) {
                _url = this.appendParamToURL(_url, name, value);
            }.bind(this)
        );
        return _url;
    },

    /**
	 * @function
	 * @description
	 * @param {string} url - url to append
	 * @returns {string} path - path to append
	 */
    toAbsoluteUrl: function (url) {
        if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
            // eslint-disable-next-line no-param-reassign
            url = '/' + url;
        }
        return url;
    },

    /**
	 * @function
	 * @description Scrolls a browser window to a given x point
	 * @param {string} xLocation - The x coordinate
	 */
    scrollBrowser: function (xLocation) {
        $('html, body').animate({ scrollTop: xLocation }, 500);
    },

    disableScroll: function () {
        var platform = window.navigator.platform;
        var windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
        if (windowsPlatforms.indexOf(platform) !== -1) {
            $('body').addClass('body-scroll-disable-win');
        } else {
            $('body').addClass('body-scroll-disable');
        }
    },

    enableScroll: function () {
        $('body').removeClass('body-scroll-disable-win');
        $('body').removeClass('body-scroll-disable');
    },

    getErrorMessage: function (status, exception) {
        const statusMessages = {
            0: 'The server is not responding. Please check your network connection and try again.',
            404: 'The requested resource was not found on the server. [404]',
            500: 'The server encountered an unexpected condition that prevented it from fulfilling the request. [500]',
        };

        if (statusMessages[status]) {
            return statusMessages[status];
        }

        const exceptionMessages = {
            parsererror: 'Failed to parse server response.',
            timeout: 'The request timed out.',
            abort: 'The request was aborted by the client.',
        };

        if (exceptionMessages[exception]) {
            return exceptionMessages[exception];
        }

        return `An unexpected error occurred. ${exception}`;
    },
};

module.exports = util;
